import { Provider } from "react-redux";
import BlogList from "./components/BlogList";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import SearchBar from "./components/SearchBar";
import store from "./redux/store";

function App() {
    return (
        <Provider store={store}>
            <Navbar />
            <SearchBar />
            <BlogList />
            <Footer />
        </Provider>
    );
}

export default App;
